import { useSiteSettings } from '../../context/SiteSettingsContext';

export const formatPrice = (price: string | number): string => {
  const { currency } = useSiteSettings();
  const locale = currency === 'USD' ? 'en-US' : 'fr-FR';

  const parsedPrice = typeof price === 'string' ? parseFloat(price) : price;

  if (isNaN(parsedPrice)) {
    console.error('Invalid price value:', price);
    return String(price);
  }

  return parsedPrice.toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
